

































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";

class PageClientRequest extends PageRequest {
  keyword: string = "";
}

@Component({
  components: {},
})
export default class Clients extends AbpBase {
  edit(row) {
    this.$root.$router.push({
      name: "client/:type/:id",
      params: { type: "edit", id: row.id },
    });
  }

  view(row) {
    this.$root.$router.push({
      name: "client/:type/:id",
      params: { type: "view", id: row.id },
    });
  }

  pagerequest: PageClientRequest = new PageClientRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
    return this.$store.state.client.list;
  }
  get loading() {
    return this.$store.state.client.loading;
  }

  create() {
    this.$root.$router.push({
      name: "client/:type/:id",
      params: { type: "create", id: "0" },
    });
  }
  pageChange(page: number) {
    this.$store.commit("client/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("client/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "client/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.client.pageSize;
  }
  get totalCount() {
    return this.$store.state.client.totalCount;
  }
  get currentPage() {
    return this.$store.state.client.currentPage;
  }
  columns = [
    {
      title: this.L("Code"),
      width: 100,
      key: "id",
    },
    {
      title: this.L("ShortName"),
      key: "shortName",
    },
    {
      title: this.L("ClientName"),
      key: "name",
    },
    {
      title: this.L("ContactName"),
      key: "contactName",
    },
    {
      title: this.L("ContactPhone"),
      key: "contactPhone",
    },
    {
      title: this.L("Action"),
      key: " ",
      width: 250,
      align: "center",
      render: (h: any, params: any) => {
        const isActive = params.row.status === "ACTV";
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.view(params.row);
                },
              },
            },
            this.L("View")
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
                display: this.hasPermission("Configs.Clients.Update")
                  ? ""
                  : "none",
              },
              on: {
                click: () => {
                  this.edit(params.row);
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: isActive ? "error" : "success",
                size: "small",
              },
              style: {
                display: this.hasPermission("Configs.Clients.ChangeStatus")
                  ? ""
                  : "none",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content:
                      (isActive
                        ? this.L("UpdateACTVStatusConfirm")
                        : this.L("UpdateINACTVStatusConfirm")) +
                      " [" +
                      params.row.name +
                      "]",
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "client/updateStatus",
                        payload: { id: params.row.id },
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            isActive ? this.L("InActive") : this.L("Active")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
